import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import "./../../index.css"

const EventDetailsPage = () => {
  const { id } = useParams();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    axios.get(`/api/event/get/${id}`)
      .then(res => setEvent(res.data))
      .catch(err => console.error(err));
  }, [id]);

  function FormattedDate(dateStr) {
    const date = new Date(dateStr);
    const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit',hour12: true};
    const formatted = date.toLocaleDateString('en-US', options);
    return <span>{formatted}</span>;
  }
  if (!event) return <div className="p-8">Loading...</div>;

  return (
  <>
    <div className="full-bleed">
      {/* Event Banner */}
      <img
        src={
          event.eventData.imageList?.[0]?.imageUrl ||
          "https://kokaki-images.s3.amazonaws.com/uploads%2Fimage+%285%29.png"
        }
        alt={event.eventData.eventName}
        className="block w-full h-[450px] object-cover"
      />
      </div>
      <div>
        {/* Event Title */}
        <div className="mt-6 justify-start text-black text-2xl font-semibold font-['Inter']">
          {event.eventData.eventName}
        </div>

        {/* Event Description */}
        <p className="mt-6 justify-start text-black text-xs font-normal font-['Poppins']">
          {event.eventData.eventDescription}
        </p>

        {/* Artist Section */}
        {Array.isArray(event.eventArtists) && event.eventArtists.length > 0 && (
          <>
            <div className="mt-6 justify-start text-black text-2xl font-semibold font-['Inter']">Artist</div>

            <div className="grid grid-cols-2 md:grid-cols-8 gap-2 mt-4">
              {event.eventArtists.map((artist, index) => {
                const image = artist.artistImages?.[0];

                return (
                  <div key={index}>
                    {/* Artist Image */}
                    {image && (
                      <img
                        src={image.imageUrl}
                        alt={image.altText || "Artist Image"}
                        className="w-35 h-40"
                      />
                    )}

                    {/* Artist Name  Role */}
                    <div className="w-80 h-16 justify-start">
                    <span className="text-black text-sm font-semibold font-['Poppins']">{artist.artistName}<br/></span>
                    <span className="text-black text-xs font-normal font-['Poppins']">{artist.artistRole}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </>
  );

};

export default EventDetailsPage;
